module.exports = __webpack_public_path__ + "static/media/07.6a26c6d0.jpg";